var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"newsticker-box"},[_c('ul',{style:(_vm.styles)},_vm._l((_vm.list),function(item){return _c('li',{key:item.id},[_vm._v(" "+_vm._s(item.title['zh-cn'])+" ")])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }